import {
    FAIL_MXI_CHAMPIONSHIP_PLAYERS_POOL,
    REQUEST_MXI_CHAMPIONSHIP_PLAYERS_POOL,
    SUCCESS_MXI_CHAMPIONSHIP_PLAYERS_POOL,
  } from '../../../actions/entities/mxi/championshipPlayerPool';
  import {createReducer} from '../../utilities';
  
  const initialState = {
    data: null,
    error: false,
    isFetching: false,
  };
  
  function requestFetch(state) {
    return {
      ...state,
      isFetching: true,
    };
  }
  
  function successFetch(state, action) {
    return {
      ...state,
      data: action.response.players,
      isFetching: false,
    };
  }
  
  function failFetch(state, action) {
    const {error} = action;
    return {
      ...state,
      isFetching: false,
      error,
    };
  }
  
  export default createReducer(initialState, {
    [REQUEST_MXI_CHAMPIONSHIP_PLAYERS_POOL]: requestFetch,
    [SUCCESS_MXI_CHAMPIONSHIP_PLAYERS_POOL]: successFetch,
    [FAIL_MXI_CHAMPIONSHIP_PLAYERS_POOL]: failFetch,
  });
  


// WEBPACK FOOTER //
// ./src/reducers/app/mxi/championshipPlayerPool.js